import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import Select from 'react-select';

class AirspaceResponsibleUnitiesAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      active_tpo: 0,
      id: this.props.id,
      data: [],
    };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.id !== "undefined" && (this.state.loaded === 0)) {
      this.setState({id: newProps.id});
    }
    if(Array.isArray(newProps.data) && (this.state.loaded === 0)) {
      this.setState({data: newProps.data, loaded:1});
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      airspace_responsible_id: this.state.id,
      name: this.state.name,
      email: this.state.email,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controlador/unidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ data: responseJson.data.main });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.props.refreshSelect(responseJson.data.airspace_responsible_unities_select);
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var data_info_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/controlador/unidade/' + data_info_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            self.props.refreshLocations(responseJson.data.airspace_responsible_unities_select, responseJson.data.airspace_responsible_unity_locations);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <h3>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.titulo}</h3>
  <hr />
  <form onSubmit={this.add}>
    <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.formulario.Email}:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
    </div>
    <div>
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.formulario.botaoAdicionarUnidade}</button>
    </div>
  </form>
  <hr />
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.tabela.Unidade}</th>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.tabela.Email}</th>
          <th>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.unidades.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="dates">
      {Object.keys(self.state.data).map(function(k) {
        var data_info = self.state.data[k];
        return (
          <tr>
            <td>{data_info.name}</td>
            <td>{data_info.email}</td>
            <td>
              <button className="btn btn-sm btn-danger" value={data_info.id} onClick={self.delete}>
                <i className="fa fa-fw fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default AirspaceResponsibleUnitiesAdd;



// WEBPACK FOOTER //
// ./src/Components/AirspaceResponsibles/Elements/AirspaceResponsibleUnitiesAdd.js